import { createStore, applyMiddleware, combineReducers } from 'redux';
import { persistCombineReducers, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import reduxThunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'react-router-redux';
import AuthRedux from './redux/AuthRedux';
import TitleRedux from './redux/TitleRedux';
import dictionary from './redux/DictionaryRedux';
import card from './redux/BuyCardRedux';
import AuthCustomer from './redux/AuthCustomerRedux';
import NavbarTitleRedux from './redux/NavbarTitleRedux';
import DrawerCardRedux from './redux/DrawerCardRedux';
import navbar from './views/orderRegister/components/NavBar/reducer';
const rootPersistConfig = {

  key: 'root',
  storage,
  blacklist: [
    'navbar',
    'toastr',
    'cart',
  ],
  // debug: true,
};
const rootReducer = persistCombineReducers(rootPersistConfig, {
  AuthRedux,
  dictionary,
  TitleRedux,
  card,
  AuthCustomer,
  NavbarTitleRedux,
  navbar,
  DrawerCardRedux
}); 


const history = createBrowserHistory();
//const rootReducer = createRootReducer(history);

const middleware = [reduxThunk];
const store = createStore(
  rootReducer,
  undefined,
  applyMiddleware(...middleware, routerMiddleware(history)),
);

persistStore(store);
export { history };
export default store;
